import { DomainSearchSuiteModule, Statuses } from '@wix/domains-search-suite';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SearchGateHomeContent } from '../SearchGateHome';
import { HarmonyDomainsResultsPage } from './ResultsPage';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../../constants';

// Skip the TransferIn modal and go straight to the connect-domain flow
export const harmonyStatusesOverrides = {
  transfer: Statuses.connect
};
export let GatePath = /*#__PURE__*/function (GatePath) {
  GatePath["RESULTS"] = "/results";
  GatePath["GATE"] = "/";
  return GatePath;
}({});
export const HarmonySiteSearchGate = _ref => {
  let {
    handlers,
    externalViewer
  } = _ref;
  const {
    experiments
  } = getPremiumEssentialsSafe() ?? {};
  const harmonyUiConfig = {
    fullPage: true,
    useUpgradePaywall: Boolean(experiments == null ? void 0 : experiments[ExperimentSpecs.HarmonyUpgradePaywall])
  };
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: GatePath.RESULTS,
    render: () => /*#__PURE__*/React.createElement(HarmonyDomainsResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      uiConfig: harmonyUiConfig
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: GatePath.GATE,
    render: () => /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
      translations: {
        Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
      },
      actions: {
        enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
        handlers,
        siteInfo: {
          externalViewer: Boolean(externalViewer)
        },
        uiConfig: harmonyUiConfig,
        statusesOverrides: harmonyStatusesOverrides
      }
    }, /*#__PURE__*/React.createElement(SearchGateHomeContent, {
      hideBackButton: true
    }))
  })));
};
//# sourceMappingURL=HarmonySiteSearchGate.js.map